<ion-item class="item-background-color" detail="false">
  <ion-label>{{ label | translate }}</ion-label>
  <ion-datetime-button slot="end" [datetime]="label" (click)="openDatePicker()"></ion-datetime-button>
</ion-item>

<ion-popover #datetimepopover [keepContentsMounted]="true" >
  <ng-template>
    <ion-datetime
      color="dark"
      [id]="label"
      [value]="value"
      [presentation]="presentation"
      [min]="min"
      [max]="max"
      [minuteValues]="minuteValues"
      [showDefaultButtons]="true"
      [preferWheel]="preferWheel"
      (ionChange)="updateValue($event)">
    </ion-datetime>
  </ng-template>
</ion-popover>